import LogoSvg from '../../../1_shared/assets/pictures/logo.svg';
import { Spin } from 'antd';
import styles from '../../styles/Loading.module.scss';

const Loading = () => {
  return (
    <div className={styles.root}>
      <img src={LogoSvg} alt="DoTherapy" style={{ minHeight: '150px' }} />
      <Spin size={'large'} />
    </div>
  );
};

export default Loading;
